import { AccountInfo, InteractionStatus } from '@azure/msal-browser';
import { createContext } from 'react';

export type AuthContextType = {
  isAuthenticated: boolean;
  user: AccountInfo | null;
  login: () => Promise<void>;
  logout: () => Promise<void>;
  inProgress: InteractionStatus;
};

export const AuthContext = createContext<AuthContextType | undefined>(
  undefined,
);
